import React from 'react';
import { CellProps } from 'react-table';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/report-actions.module.scss';
import { IReportPayroll } from 'src/types/reportPayroll';
import PaidPayrollAction from './PaidPayrollAction';
import history from 'src/navigation/history';
import { changeToZeroMoment } from '../../../../../../../helpers/timeHelpers';
//import DeleteReportPayrollAction from './DeleteReportPayrollAction';

const ReportPayrollActionsColumn: React.FunctionComponent<CellProps<IReportPayroll>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IReportPayroll>) => {
    const linkToList = () => {
        history.push(Router.generate(routes.PAYROLLS_LIST), {
            periodStart: original.periodStart?.date ? changeToZeroMoment(original.periodStart?.date, 'YYYY-MM-DD') : '',
            periodEnd: original.periodEnd?.date ? changeToZeroMoment(original.periodEnd?.date, 'YYYY-MM-DD') : '',
        });
    };
    return (
        <div className={classNames(styles.actions)}>
            <button className={'btn btn-outline-info'} onClick={() => linkToList()}>
                <FontAwesomeIcon icon={faSearch} />
                View
            </button>
            <PaidPayrollAction data={original} />
            {/*<DeleteReportPayrollAction data={original} />*/}
        </div>
    );
};

export default ReportPayrollActionsColumn;
